import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonModal, ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';

// NAPLO – Tárhely fiókok (intézmény-szintű, ügyféltől függetlenül). Globális fiókkezelés +
// élő TOTP 6 jegyű kódok Google Authenticator-szerű, fogyó körös időzítővel.
@Component({
  selector: 'app-naplo-fiokok',
  templateUrl: './fiokok.component.html',
  styleUrls: ['../naplo-shared.scss', './fiokok.component.scss'],
})
export class FiokokComponent implements OnInit, OnDestroy {
  @ViewChild('fiokModal') fiokModal: IonModal;
  intezmeny = '';
  fiokok: any[] = [];
  kodok: any[] = [];
  period = 30;
  remaining = 30;
  szerk: any = null;
  private timer: any = null;
  /*  CÉG → FIÓK. Fiókból kevés van, cégből sok, ezért a hozzárendelést a CÉGEK listájáról
   *  vezetjük: minden cég egy sor, mellette a hozzá tartozó KAÜ-belépés(ek). A tárhely- és
   *  önkormányzat-lekérés ebből tudja, melyik cég nevében kell belépni. */
  ugyfelek: any[] = [];
  parok: any[] = [];                      // az intézmény összes hozzárendelése (cég ↔ fiók)
  kereses = '';
  csakHianyzo = false;                    // csak azok a cégek, akikhez még nincs fiók
  hozza: any = null;                      // az épp felvitt hozzárendelés (a cég sorában)
  ellenorzes: string | null = null;       // az épp ellenőrzött fiók (belépés-próba)

  constructor(private naplo: NaploService, private toast: ToastController, private alert: AlertController) {}

  async ngOnInit() {
    const a = await this.naplo.init();
    this.intezmeny = a.intezmeny;
    await this.betoltFiokok();
    await this.betoltUgyfelek();
    await this.betoltParok();
    await this.betoltKodok();
    // 1 mp-es timer: fogyó kör; ha a periódus lejár, új kódokat kérünk.
    this.timer = setInterval(() => {
      this.remaining -= 1;
      if (this.remaining <= 0) this.betoltKodok();
    }, 1000);
  }
  ngOnDestroy() { if (this.timer) clearInterval(this.timer); }

  async betoltFiokok() {
    try { this.fiokok = await this.naplo.get('/ugyfelkapu/fiokok/' + this.intezmeny); }
    catch { this.hiba('Nem sikerült betölteni a fiókokat.'); }
  }
  async betoltParok() {
    try { this.parok = await this.naplo.get('/ugyfelkapu/ceg-fiokok/' + this.intezmeny); }
    catch { this.parok = []; }
  }
  async betoltUgyfelek() {
    try { this.ugyfelek = await this.naplo.get('/ugyfelek/' + this.intezmeny); }
    catch { this.ugyfelek = []; }
  }
  /** Egy cég KAÜ-belépései (ügyfélkapu és/vagy cégkapu). */
  cegFiokjai(u: any) { return this.parok.filter((p) => p.ugyfel_id === u.id); }
  /** A képernyőn mutatott cégsorok: keresés és „csak akinek nincs fiókja" szűréssel. */
  get cegSorok(): any[] {
    const k = this.kereses.trim().toLowerCase();
    return this.ugyfelek.filter((u) => {
      if (this.csakHianyzo && this.cegFiokjai(u).length) return false;
      if (!k) return true;
      return `${u.nev || ''} ${u.adoszam || ''}`.toLowerCase().includes(k);
    });
  }
  /** Szünetel-e a fiók sikertelen belépés miatt. */
  fiokHibas(fiokId: string) { return !!this.fiokok.find((f) => f.id === fiokId)?.belepes_hiba; }

  /** Belépés-próba a szünetelő fiókkal (pl. az ügyfél feloldotta a KAÜ-fiókját): siker → a szinkron újraindul. */
  async ellenoriz(f: any) {
    this.ellenorzes = f.id;
    try {
      await this.naplo.post('/ugyfelkapu/fiok/' + f.id + '/ellenoriz', {});
      this.ok('A belépés sikerült – a fiók szinkronja újraindul.');
    } catch (e: any) { this.hiba(e?.error?.error || 'A belépés nem sikerült.'); }
    finally { this.ellenorzes = null; await this.betoltFiokok(); }
  }
  fiokCimke(f: any) { return f.fiok_cimke || f.cimke || f.fiok_login || f.login; }

  /** Új KAÜ-belépés a cég sorában (egy fiók, típus és – ha kell – tárhely-név). */
  ujHozzarendeles(u: any) {
    this.hozza = { ugyfel_id: u.id, fiok_id: this.fiokok[0]?.id || '', tipus: 'ugyfelkapu', mailbox_nev: '' };
  }
  async hozzarendelesMent() {
    if (!this.hozza?.fiok_id) return this.hiba('Válassz ügyfélkapu-fiókot.');
    try {
      await this.naplo.post('/ugyfelkapu/hozzarendeles', this.hozza);
      this.hozza = null;
      await this.betoltFiokok(); await this.betoltParok();
      this.ok('Fiók hozzárendelve a céghez.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült hozzárendelni.'); }
  }
  async hozzarendelesTorol(p: any, ugyfelNev: string) {
    const a = await this.alert.create({
      header: 'Hozzárendelés törlése', message: `${ugyfelNev} leválasztása a(z) „${this.fiokCimke(p)}" fiókról?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => {
        try { await this.naplo.del('/ugyfelkapu/hozzarendeles/' + p.id); await this.betoltFiokok(); await this.betoltParok(); this.ok('Leválasztva.'); }
        catch { this.hiba('Nem sikerült törölni.'); }
      } }],
    });
    a.present();
  }

  async betoltKodok() {
    try {
      const r: any = await this.naplo.get('/ugyfelkapu/totp/' + this.intezmeny);
      this.kodok = r.kodok || []; this.period = r.period || 30; this.remaining = r.remaining || this.period;
    } catch { /* csendes */ }
  }

  kodFor(fiokId: string) { return this.kodok.find(k => k.id === fiokId); }
  korPct() { return Math.max(0, Math.min(100, (this.remaining / this.period) * 100)); }
  korSzin() { return this.remaining <= 5 ? '#dc2626' : '#0f766e'; }

  async masol(code: string) {
    if (!code) return;
    try { await navigator.clipboard.writeText(code); this.ok('Kód másolva: ' + code); }
    catch { this.ok('Kód: ' + code); }
  }

  uj() { this.szerk = { intezmeny: this.intezmeny, cimke: '', login: '', jelszo: '', totp_secret: '', aktiv: true }; this.fiokModal.present(); }
  szerkeszt(f: any) { this.szerk = { ...f, intezmeny: this.intezmeny, jelszo: '', totp_secret: '' }; this.fiokModal.present(); }
  async mentes() {
    if (!this.szerk?.login?.trim()) return this.hiba('A login kötelező.');
    try {
      if (this.szerk.id) await this.naplo.put('/ugyfelkapu/fiok/' + this.szerk.id, this.szerk);
      else await this.naplo.post('/ugyfelkapu/fiok', this.szerk);
      await this.fiokModal.dismiss();
      await this.betoltFiokok(); await this.betoltKodok();
      this.ok('Fiók mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  async torol(f: any) {
    const a = await this.alert.create({
      header: 'Törlés', message: `Biztosan törli a fiókot (${f.cimke || f.login})? A hozzárendelései is törlődnek.`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, {
        text: 'Törlés', role: 'destructive', handler: async () => {
          try { await this.naplo.del('/ugyfelkapu/fiok/' + f.id); await this.betoltFiokok(); await this.betoltKodok(); this.ok('Törölve.'); }
          catch { this.hiba('Nem sikerült törölni.'); }
        }
      }],
    });
    a.present();
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2800, color: 'danger' })).present(); }
}
